export const STATUS_META = {
    Inkommit: { color: "text-sky-300", border: "border-sky-400/30", dot: "bg-sky-400" },
    Utredning: { color: "text-amber-300", border: "border-amber-400/30", dot: "bg-amber-400" },
    "Pågående": { color: "text-[#C4A977]", border: "border-[#C4A977]/40", dot: "bg-[#C4A977]" },
    Avslutat: { color: "text-emerald-300", border: "border-emerald-400/30", dot: "bg-emerald-400" },
};

export const STATUS_STEPS = ["Inkommit", "Utredning", "Pågående", "Avslutat"];

export function StatusChip({ status }) {
    const meta = STATUS_META[status] || STATUS_META.Inkommit;
    return (
        <span
            data-testid={`status-chip-${status}`}
            className={`inline-flex items-center gap-2 px-3 py-1 text-xs border ${meta.border} ${meta.color} rounded-sm tracking-wide`}
        >
            <span className={`w-1.5 h-1.5 rounded-full ${meta.dot}`} />
            {status}
        </span>
    );
}

export function StatusStepper({ status }) {
    const idx = STATUS_STEPS.indexOf(status);
    return (
        <div className="flex items-center gap-2">
            {STATUS_STEPS.map((s, i) => {
                const active = i <= idx;
                return (
                    <div key={s} className="flex items-center gap-2">
                        <div
                            className={`flex items-center gap-2 ${
                                active ? "text-[#F4F4F5]" : "text-[#A1A1AA]/50"
                            }`}
                        >
                            <span
                                className={`w-2 h-2 rounded-full ${
                                    active ? "bg-[#C4A977]" : "bg-white/10"
                                }`}
                            />
                            <span className="text-xs uppercase tracking-wider">
                                {s}
                            </span>
                        </div>
                        {i < STATUS_STEPS.length - 1 && (
                            <span
                                className={`w-6 sm:w-10 h-px ${
                                    i < idx ? "bg-[#C4A977]" : "bg-white/10"
                                }`}
                            />
                        )}
                    </div>
                );
            })}
        </div>
    );
}
